import { render, staticRenderFns } from "./more-setting.vue?vue&type=template&id=5dacacad&scoped=true&"
import script from "./more-setting.vue?vue&type=script&lang=js&"
export * from "./more-setting.vue?vue&type=script&lang=js&"
import style0 from "./more-setting.vue?vue&type=style&index=0&id=5dacacad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dacacad",
  null
  
)

export default component.exports